<script>
import Chart from "chart.js";
import { PolarArea, mixins } from "vue-chartjs";
import _ from "lodash";
import util from "util";
import "chartjs-plugin-doughnutlabel";
const { reactiveProp } = mixins;
export default {
  name: "chartjs-polar-area",
  extends: PolarArea,
  mixins: [reactiveProp],
  props: ["options"],
  mounted() {
    this.addPlugin({
      id: "fiifi-legend-adjust",
      beforeRender: function(chart) {
        // console.log(util.inspect(chart))
        if (
          chart.legend.position == "left" ||
          chart.legend.position == "right"
        ) {
          let legendHeight = _.reduce(
            chart.legend.legendHitBoxes,
            (sum, hb) => {
              return sum + hb.height || 0;
            },
            0
          );
          legendHeight = legendHeight || 1;
          let spacing = chart.legend.options.labels.padding || 1;
          legendHeight +=
            spacing * (chart.legend.legendHitBoxes.length || 1 - 1);
          let chartHeight = chart.height;
          let pad = chartHeight / 2 - legendHeight / 2;
          chart.legend.top = pad;
        }
        // move the chart itself?
        // have not found any options that will move the position of the chart model
        return true;
      }
    });
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      handler() {
        this.$data._chart.destroy();
        this.renderChart(this.chartData, this.options);
        // this.$data._chart.update();
      }
    }
  }
};
</script>
<style scoped>
canvas {
  /* width:500px !important;
  height:500px !important; */
  display: flex !important;
  align-items: flex-end !important;
}
</style>